import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
import { COLLECTION_ENTITIES_QUERY_KEY } from "collections/hooks/useCollectionEntities";
import { COLLECTION_CANDIDATES_QUERY_KEY } from "collections/hooks/useCollectionCandidates";
const updateCollectionEntities = async ({
  collectionId,
  addedEntities = [],
  removedEntities = []
}) => Collections.updateEntities(collectionId, { added_entities: addedEntities, removed_entities: removedEntities });
const bulkAddEntities = async ({
  collectionId,
  addedEntities = []
}) => Collections.bulkAdd({ entity_ids: addedEntities }, collectionId);
const bulkRemoveEntities = async ({
  collectionId,
  removedEntities = []
}) => Collections.bulkDeleteBycollectionIdAndEntitiestoremove({ entity_ids: removedEntities }, collectionId);
const useCollectionEntityMutation = (collectionId) => {
  const queryClient = useQueryClient();
  const add = useMutation({
    mutationFn: ({ addedEntities }) => updateCollectionEntities({ collectionId, addedEntities }),
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.entity_add_failed", { ns: "enterprise_collections", error: errorThrown }),
        i18n.t("notifications.entity_add_failed_title", { ns: "enterprise_collections" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.entity_add_success", { ns: "enterprise_collections" }),
        i18n.t("notifications.success_title", { ns: "enterprise_collections" })
      );
      queryClient.invalidateQueries({ queryKey: [COLLECTIONS_QUERY_KEY, collectionId], type: "active" });
      queryClient.invalidateQueries({ queryKey: [COLLECTION_ENTITIES_QUERY_KEY, collectionId], type: "active" });
      queryClient.invalidateQueries({ queryKey: [COLLECTION_CANDIDATES_QUERY_KEY, collectionId], type: "active" });
    }
  });
  const remove = useMutation({
    mutationFn: ({ removedEntities }) => updateCollectionEntities({ collectionId, removedEntities }),
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.entity_remove_failed", { ns: "enterprise_collections", error: errorThrown }),
        i18n.t("notifications.entity_remove_failed_title", { ns: "enterprise_collections" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.entity_remove_success", { ns: "enterprise_collections" }),
        i18n.t("notifications.success_title", { ns: "enterprise_collections" })
      );
      queryClient.invalidateQueries({ queryKey: [COLLECTIONS_QUERY_KEY, collectionId], type: "active" });
      queryClient.invalidateQueries({ queryKey: [COLLECTION_ENTITIES_QUERY_KEY, collectionId], type: "active" });
      queryClient.invalidateQueries({ queryKey: [COLLECTION_CANDIDATES_QUERY_KEY, collectionId], type: "active" });
    }
  });
  const bulkAdd = useMutation({
    mutationFn: ({ addedEntities }) => bulkAddEntities({ collectionId, addedEntities })
  });
  const bulkRemove = useMutation({
    mutationFn: ({ removedEntities }) => bulkRemoveEntities({ collectionId, removedEntities })
  });
  return {
    addEntities: add.mutateAsync,
    removeEntities: remove.mutateAsync,
    bulkAddEntitiesMutation: bulkAdd,
    bulkRemoveEntitiesMutation: bulkRemove
  };
};
export default useCollectionEntityMutation;
